import { createEventerFn } from './eventer';

import { isDevEnv } from '../utils/common.utils';

export const entitySelectedFromSearchPalette = createEventerFn(
  new EventTarget(),
  'entitySelectedFromSearchPalette',
  {
    log: true,
    isDev: isDevEnv,
  }
)();
